<template>
  <pagefra>
    <div
      class="log container"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <el-form-item :label="$l('操作人')">
              <el-input
                v-model="form.operator"
                :placeholder="$l('操作人')"
                style="width: 110px"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('操作模块')">
              <el-select
                v-model="form.operateModule"
                :placeholder="$l('操作模块')"
              >
                <el-option :label="$l('操作模块')" value></el-option>
                <el-option :label="$l('登录')" value="登录"></el-option>
                <el-option :label="$l('信息概览')" value="信息概览"></el-option>
                <el-option :label="$l('服务套餐')" value="服务套餐"></el-option>
                <el-option :label="$l('信息概览（大屏版）')" value="信息概览（大屏版）"></el-option>
                <el-option :label="$l('电梯AI运行诊断（大屏版）')" value="电梯AI运行诊断（大屏版）"></el-option>
                <el-option :label="$l('电梯风险监测（大屏版）')" value="电梯风险监测（大屏版）"></el-option>
                <el-option :label="$l('电梯设备巡视（大屏版）')" value="电梯设备巡视（大屏版）"></el-option>
                <el-option :label="$l('电梯体检分析')" value="电梯体检分析"></el-option>
                <el-option :label="$l('设备巡视')" value="设备巡视"></el-option>
                <el-option :label="$l('实时监视')" value="实时监视"></el-option>
                <el-option :label="$l('报警管理')" value="报警管理"></el-option>
                <el-option
                  :label="$l('故障短信管理')"
                  value="故障短信管理"
                ></el-option>
                <el-option :label="$l('故障处理')" value="故障处理"></el-option>
                <el-option :label="$l('视频设备管理')" value="视频设备管理"></el-option>
                <el-option :label="$l('视频日志管理')" value="视频日志管理"></el-option>
                <el-option :label="$l('用户确认风险告知书记录')" value="用户确认风险告知书记录"></el-option>
                <el-option :label="$l('液晶屏设备管理')" value="液晶屏设备管理"></el-option>
                <el-option :label="$l('故障信息管理')" value="故障信息管理"></el-option>
                <el-option :label="$l('诊断信息管理')" value="诊断信息管理"></el-option>
                <el-option :label="$l('电梯巡检报告')" value="电梯巡检报告"></el-option>
                <el-option :label="$l('地盘报告统计')" value="地盘报告统计"></el-option>
                <el-option :label="$l('维保管理')" value="维保管理"></el-option>
                <el-option :label="$l('维保监督')" value="维保监督"></el-option>
                <el-option :label="$l('物业报价单管理')" value="物业报价单管理"></el-option>
                <el-option :label="$l('物业应付款管理')" value="物业应付款管理"></el-option>
                <el-option :label="$l('年检计划管理')" value="年检计划管理"></el-option>
                <el-option :label="$l('配件提案书管理')" value="配件提案书管理"></el-option>
                <el-option :label="$l('故障上报管理')" value="故障上报管理"></el-option>
                <el-option :label="$l('服务问题反馈管理')" value="服务问题反馈管理"></el-option>
                <el-option :label="$l('统计分析')" value="统计分析"></el-option>
                <el-option :label="$l('投屏展示')" value="投屏展示"></el-option>
                <el-option
                  :label="$l('电梯档案')"
                  value="电梯档案"
                ></el-option>
                <el-option
                  :label="$l('物业信息维护')"
                  value="物业信息维护"
                ></el-option>
                <el-option
                  :label="$l('业主信息维护')"
                  value="业主信息维护"
                ></el-option>
                <el-option
                  :label="$l('账号管理功能')"
                  value="账号管理功能"
                ></el-option>
                <el-option
                  :label="$l('角色管理功能')"
                  value="角色管理功能"
                ></el-option>
                <el-option
                  :label="$l('异常反馈功能')"
                  value="异常反馈功能"
                ></el-option>
                <el-option
                  :label="$l('日志管理功能')"
                  value="日志管理功能"
                ></el-option>
                <el-option
                  :label="$l('短信接收人管理')"
                  value="短信接收人管理"
                ></el-option>
                <el-option
                  :label="$l('微信用户管理')"
                  value="微信用户管理"
                ></el-option>
                <el-option
                  :label="$l('微信推送管理')"
                  value="微信推送管理"
                ></el-option>
                <el-option :label="$l('公告管理')" value="公告管理"></el-option>
                <el-option
                  :label="$l('第三方应用账号管理')"
                  value="第三方应用账号管理"
                ></el-option>
                <el-option :label="$l('第三方系统信息管理')" value="第三方系统信息管理"></el-option>
                <el-option :label="$l('账户视频设备管理')" value="账户视频设备管理"></el-option>
                <el-option :label="$l('退出')" value="退出"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('操作类型')">
              <el-select
                v-model="form.operateType"
                :placeholder="$l('操作类型')"
              >
                <el-option :label="$l('操作类型')" value></el-option>
                <el-option :label="$l('登录')" value="登录"></el-option>
                <el-option :label="$l('访问')" value="访问"></el-option>
                <el-option :label="$l('新增')" value="新增"></el-option>
                <el-option :label="$l('修改')" value="修改"></el-option>
                <el-option :label="$l('删除')" value="删除"></el-option>
                <el-option :label="$l('启用')" value="启用"></el-option>
                <el-option :label="$l('禁用')" value="禁用"></el-option>
                <el-option :label="$l('解绑')" value="解绑"></el-option>
                <el-option :label="$l('设置权限')" value="设置权限"></el-option>
                <el-option :label="$l('数据权限')" value="数据权限"></el-option>
                <el-option :label="$l('远程设置')" value="远程设置"></el-option>
                <el-option :label="$l('启用')" value="启用"></el-option>
                <el-option :label="$l('禁用')" value="禁用"></el-option>
                <el-option
                  :label="$l('一键上报故障')"
                  value="一键上报故障"
                ></el-option>
                <el-option :label="$l('保存')" value="保存"></el-option>
                <el-option :label="$l('反馈')" value="反馈"></el-option>
                <el-option :label="$l('回复')" value="回复"></el-option>
                <el-option :label="$l('评价')" value="评价"></el-option>
                <el-option :label="$l('处理')" value="处理"></el-option>
                <el-option
                  :label="$l('导入电梯权限')"
                  value="导入电梯权限"
                ></el-option>
                <el-option :label="$l('一键生成日报')" value="一键生成日报"></el-option>
                <el-option :label="$l('生成报告')" value="生成报告"></el-option>
                <el-option :label="$l('设置')" value="设置"></el-option>
                <el-option :label="$l('退出')" value="退出"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('客户端类型')">
              <el-select
                v-model="form.clientType"
                :placeholder="$l('客户端类型')"
              >
                <el-option :label="$l('客户端类型')" value="0"></el-option>
                <el-option :label="$l('微信公众号')" value="1"></el-option>
                <el-option :label="$l('PC端')" value="2"></el-option>
                <el-option :label="$l('微信小程序')" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('创建时间')">
              <el-date-picker
                v-model="logTimeValues"
                type="datetimerange"
                :range-separator="$l('至')"
                :start-placeholder="$l('开始时间')"
                :end-placeholder="$l('结束时间')"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <!-- <el-button
              icon="el-icon-close"
              round
              @click="deleteLog"
              v-show="hasPermission('删除')"
            >删除</el-button> -->
            <el-button
              round
              icon="el-icon-download"
              @click="exportLog"
              v-if="hasPermission('导出')"
              >{{ $l("导出") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
            @selection-change="selectChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              :label="$l('序号')"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('操作人')"
              prop="operator"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('操作模块')"
              prop="operateModule"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('操作类型')"
              prop="operateType"
              align="center"
              width="120"
            ></el-table-column>
            <!-- <el-table-column
              :label="$l('用户IP')"
              prop="clientIp"
              align="center"
              width="120"
            ></el-table-column> -->
            <el-table-column
              :label="$l('客户端')"
              prop="clientType"
              align="center"
              width="120"
              :formatter="clientTypeFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('操作备注')"
              prop="remark"
              align="center"
              width="200"
            ></el-table-column>
            <el-table-column
              :label="$l('创建时间')"
              prop="createDate"
              align="center"
              width="200"
              sortable
            ></el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import breadcrumb from "@/components/breadcrumb.vue";
import global from "@/mixins/global.js";
export default {
  name: "log",
  mixins: [global],
  components: {
    panel,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        operator: "",
        operateModule: "",
        operateType: "",
        clientType: "0",
        startDate: "",
        endDate: "",
      },
      logTimeValues: [],
      tableData: [],
      selectedList: [],
      loading: false,
      fullLoading: false,
    };
  },
  mounted() {
    this.logTimeValues = this.$common.getTimeRange(7);
    if (this.loaded) {
      this.initData();
    }
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      if (this.logTimeValues && this.logTimeValues.length == 2) {
        this.form.startDate = this.$common.formatDateTime(
          this.logTimeValues[0]
        );
        this.form.endDate = this.$common.formatDateTime(this.logTimeValues[1]);
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      this.loading = true;
      this.$http
        .get(this.$apiConfig.search_log_url, {
          params: this.form,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    clientTypeFormatter(row) {
      if (row.clientType == 1) {
        return "微信公众号";
      } else if (row.clientType == 2) {
        return "PC端";
      } else if (row.clientType == 3) {
        return "微信小程序";
      } else {
        return "";
      }
    },
    selectChange(selection) {
      this.selectedList = selection;
    },
    deleteLog() {
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择要删除的数据");
        return;
      }
      this.confirmAlert(() => {
        let idList = [];
        for (let i = 0; i < len; i++) {
          idList.push(this.selectedList[i].logId);
        }
        let formData = new FormData();
        formData.append("idList", idList);
        this.$http
          .post(this.$apiConfig.delete_log_url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.search();
            }
          })
          .catch((error) => {
            this.errorMessage(this.messageType.delete);
            this.$sentry.captureException(error);
          });
      });
    },
    exportLog() {
      if (this.logTimeValues && this.logTimeValues.length == 2) {
        this.form.startDate = this.$common.formatDateTime(
          this.logTimeValues[0]
        );
        this.form.endDate = this.$common.formatDateTime(this.logTimeValues[1]);
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      this.fullLoading = true;
      let filename =
        "日志管理表_" + this.$common.formatCurrentDateTime(false) + ".xlsx";
      this.$http({
        url: this.$apiConfig.export_log_url,
        method: "post",
        responseType: "blob",
        data: this.form,
      })
        .then((response) => {
          this.fullLoading = false;
          const status = response.status;
          if (status != 200) {
            this.message(
              1,
              status == 201
                ? "导出失败"
                : status == 202
                ? "没有数据"
                : "数据量过大"
            );
            return;
          }
          const data = response.data;
          var blob = new Blob([data]);
          //判断是不是ie的浏览器
          if (!!window.ActiveXObject || "ActiveXObject" in window) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.download = filename;
            aLink.href = url;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.log {
  em {
    color: red;
  }
}
</style>
